import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { Dashboard } from '../pages/dashboard';
import { Tasks } from '../pages/tasks';
import { Projects } from '../pages/projects';
import { ProjectSettings } from '../pages/projectSettings';
import { Users } from '../pages/users';

export const Router = () => (
  <Routes>
    <Route path="/" element={<Dashboard />} />
    <Route path="/dashboard" element={<Dashboard />} />
    <Route path="/tasks" element={<Tasks />} />
    <Route path="/projects" element={<Projects />} />
    <Route path="/projects/:id" element={<ProjectSettings />} />
    <Route path="/users" element={<Users />} />
    <Route path="*" element={<Navigate to="/tasks" replace />} />
  </Routes>
);
